module.exports = __webpack_public_path__ + "resources/img/img_appguard2_m.7cd434917e4d49270a66366fe38dc65e.png";